import * as React from "react";
import { compose, isDefined } from "@grandvisionhq/utils";
import { extractSkusFromBrParameters, generateConditionalClassNames } from "../../../../utils/containers/RowComponent/utils/utils.js";
/* empty css                         */
import { withBloomreachData } from "../../../../../../hocs/hocs/with-bloomreach-data.js";
import { withEditableContent } from "../../../../../../hocs/hocs/with-editable-content.js";
import { ProductListingRow } from "../../../../../../components/ProductListingRow/components/ProductListingRow/ProductListingRow.js";
const CmsRowProductListBySku = ({ component }) => {
  const parameters = component.getParameters();
  const { horizontalAlignment, verticalAlignment } = parameters;
  const skus = extractSkusFromBrParameters(parameters);
  const rowSkuClassName = generateConditionalClassNames("br-row-sku", {
    horizontalAlignment,
    verticalAlignment
  });
  if (!isDefined(skus) || skus.length === 0) return null;
  return /* @__PURE__ */ React.createElement("div", { className: rowSkuClassName, "data-t": "br-row-sku" }, /* @__PURE__ */ React.createElement(ProductListingRow, { skus }));
};
const RowProductListBySku = compose(
  withBloomreachData,
  withEditableContent
)(CmsRowProductListBySku);
export {
  CmsRowProductListBySku,
  RowProductListBySku as default
};
//# sourceMappingURL=RowProductListBySku.js.map
